import { NavLink } from 'react-router-dom';
import { useDemoSession } from '../../auth/DemoSessionProvider';
import { UmbLogo } from './UmbLogo';
import { WorkspaceMenu } from './WorkspaceMenu';
import { IconBellSolid, IconInfoSolid } from '../ui/icons';

function HeaderIconButton({ label, children }) {
  return (
    <button
      type="button"
      aria-label={label}
      className="flex h-9 w-9 items-center justify-center rounded-[10px] border border-[#F1F1F1] bg-[#F8F8F8] text-[#003A70] transition-colors hover:bg-[#EFEFEF] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#003A70]/25"
    >
      {children}
    </button>
  );
}

export function AppTopBar({ homeTo, homeAriaLabel }) {
  const { session } = useDemoSession();

  return (
    <header className="z-30 mx-3 mb-3 flex h-14 shrink-0 items-center justify-between gap-3 rounded-xl border border-[#F1F1F1] bg-white px-4 sm:px-5">
      <NavLink
        to={homeTo}
        end
        className="flex items-center rounded-md outline-none focus-visible:ring-2 focus-visible:ring-[#003A70]/30"
        aria-label={homeAriaLabel}
      >
        <UmbLogo alt="" className="h-7 w-auto max-w-[96px]" />
      </NavLink>

      <div className="flex items-center gap-2 sm:gap-3">
        {session?.roleLabel ? (
          <span className="hidden h-8 items-center rounded-lg border-[0.5px] border-[#003A70] bg-[rgba(153,237,255,0.1)] px-2.5 text-[13px] font-medium tracking-[-0.014em] text-[#00749F] sm:inline-flex">
            {session.roleLabel}
          </span>
        ) : null}
        <HeaderIconButton label="Notifications">
          <IconBellSolid className="h-4 w-4" />
        </HeaderIconButton>
        <HeaderIconButton label="Help & information">
          <IconInfoSolid className="h-3.5 w-3.5" />
        </HeaderIconButton>
        <WorkspaceMenu />
      </div>
    </header>
  );
}
